import { useEffect, useState } from 'react'
import RequestQueue from '../api/requestQueue'

export function useAuthResult() {
    const [auth, setAuth] = useState(() => RequestQueue.getAuthResult())

    useEffect(() => {
        const subscription = RequestQueue.authResult$.subscribe((value) => {
            setAuth(value)
        })
        return () => subscription.unsubscribe()
    }, [])

    return auth
}
